





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentPageOrganizationPhotos extends Vue {
  // Props
  @Prop({ type: Boolean, default: false })
  fixHeight: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/page/organization/photos/component.vue